import React from 'react';
import './App.css';
// import { Route, BrowserRouter, Switch, Redirect } from 'react-router-dom'
import { Route, HashRouter, Switch, Redirect } from 'react-router-dom'
import Main from './pages/Main'
import instructions from './pages/instructions/instructions'
//国际化设置中文
import { ConfigProvider } from 'antd'
import zhCN from 'antd/es/locale/zh_CN'
import moment from 'moment';
import 'moment/locale/zh-cn';
import{ setLocalStorage , getLocalStorage,removeLocalStorage} from '@/utils/LocalStorage'
moment.locale('zh-cn');

function App() {
  return (
    <ConfigProvider locale={zhCN}>
      <div className="App">
        {/* <BrowserRouter> */}
        <HashRouter>
          <Switch>
            <Route path="/Main" component={Main}/>
            <Route path="/instructions" component={instructions} />
            {/* <Route path="/Login" component={Login}></Route> */}
              {console.log("aaaccccvvvvddd")}
            <Redirect from="/" to="/instructions"></Redirect>
            <Redirect from="/Main" to="/Main/Menu"></Redirect>
          </Switch>
        </HashRouter>
      </div>
    </ConfigProvider>
);
}

export default App;
